import confirm from "./modules/fr/confirm";
import commonExt from "./modules/fr/commonExt";
import orderExt from "./modules/fr/orderExt";
import rider from "./modules/fr/rider";
import store from "./modules/fr/store";
import finance from "./modules/fr/finance";
import data from "./modules/fr/data";
import set from "./modules/fr/set";
import plugin from "./modules/fr/plugin";
import jurisdiction from "./modules/fr/jurisdiction";
import dashboardExt from "./modules/fr/dashboardExt";
import activationExt from "./modules/fr/activationExt";
import app from "./modules/fr/app";

export default {
  lang: {
    label: "Langue",
    zhCN: "Chinois simplifié",
    frFR: "Français",
  },
  header: {
    welcome: "Bienvenue, ",
    platformId: "ID plateforme : ",
    logout: "Déconnexion",
  },
  menu: {
    overview: "Aperçu",
    order: "Commandes",
    orderList: "Liste des commandes",
    revokeOrder: "Commandes annulées",
    rider: "Livreurs",
    riderList: "Liste des livreurs",
    riderAuth: "Vérification",
    riderLevel: "Niveaux",
    riderSet: "Paramètres livreurs",
    store: "Marchands",
    storeList: "Liste des marchands",
    storeValue: "Recharge marchands",
    priceSet: "Tarification",
    finance: "Finance",
    assetOverview: "Vue d'ensemble",
    riderAsset: "Actifs livreurs",
    shopAsset: "Actifs marchands",
    withdrawalList: "Retraits",
    withdrawalSet: "Paramètres retrait",
    data: "Données",
    orderAnalysis: "Analyse commandes",
    riderAnalysis: "Analyse livreurs",
    application: "Applications",
    settings: "Paramètres",
    platformSet: "Plateforme",
    agreement: "Accords",
    versionUpdate: "Mise à jour",
    noticeManage: "Annonces",
    messageManage: "Notifications",
    permission: "Permissions",
    appletList: "Mini-programmes",
    superAuth: "Super admin",
    empower: "Autorisation",
  },
  common: {
    confirm: "Confirmer",
    cancel: "Annuler",
    tip: "Rappel",
    filter: "Filtrer",
    pleaseSelect: "Veuillez choisir",
    startDate: "Date de début",
    endDate: "Date de fin",
    to: "à",
    loading: "Chargement...",
    noRowSelected: "Aucune ligne sélectionnée",
    comingSoon: "Bientôt disponible",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    search: "Rechercher",
    operation: "Actions",
    detail: "Détail",
    start: "Dép.",
    end: "Arr.",
    yuan: "yuans",
    order: "cmd.",
    person: "pers.",
    store: "mag.",
    ...commonExt,
  },
  confirm,
  orderState: {
    pending: "En attente",
    arrive: "Vers le magasin",
    pickup: "À collecter",
    delivering: "En livraison",
    completed: "Terminée",
    cancelled: "Annulée",
  },
  dashboard: {
    todayOrders: "Commandes du jour",
    yesterdayOrders: "Hier : ",
    totalOrders: "Total : ",
    todayIncome: "Chiffre du jour (yuans)",
    yesterdayIncome: "Hier : ",
    totalIncome: "Total : ",
    waitRider: "Livreurs à valider",
    onlineRider: "Livreurs en ligne",
    onlineRiderTip: "Nombre de livreurs actuellement en ligne",
    certifiedRider: "Livreurs certifiés : ",
    waitStore: "Marchands à valider",
    partnerStore: "Marchands partenaires : ",
    pendingAccept: "En attente",
    delivering: "En livraison",
    cancelRights: "Annulées / litiges",
    orderTrend: "Tendance commandes",
    incomeTrend: "Tendance revenus",
    ...dashboardExt,
  },
  order: {
    listTitle: "Liste des commandes",
    orderStatus: "Statut",
    orderTime: "Date de commande",
    orderNo: "N° commande",
    orderNoPh: "Saisir le n° de commande",
    customerTel: "Téléphone client",
    customerTelPh: "Saisir le téléphone",
    storeName: "Marchand",
    storeNamePh: "Saisir le nom du marchand",
    riderName: "Livreur",
    riderNamePh: "Saisir le nom du livreur",
    pushTime: "Heure d'envoi",
    orderType: "Type",
    takeaway: "Livraison repas",
    orderStore: "Marchand",
    orderAmount: "Montant (yuans)",
    startAddress: "Adresse",
    all: "Tout",
    acceptRider: "Livreur",
    commission: "Commission (yuans)",
    deleteConfirm: "Confirmer la suppression de cette commande ?",
    ...orderExt,
  },
  rider,
  store,
  finance,
  data,
  set,
  plugin,
  jurisdiction,
  app,
  request: {
    networkError: "Erreur de connexion au serveur",
    timeout: "Délai de requête dépassé",
    statusError: "Erreur API {code}",
    unknownError: "Erreur API inconnue",
    apiError: "Erreur API {code}",
  },
  activation: {
    enterCode: "Veuillez saisir le code d'activation",
    ...activationExt,
  },
  map: {
    locationFail: "Impossible de détecter la position actuelle",
  },
  train: {
    fillTimeRange: "Veuillez renseigner la plage horaire complète",
  },
  login: {
    title: "Admin livraison",
    subtitle: "Connectez-vous avec le compte application",
    userName: "Compte",
    userNamePh: "Saisir le compte",
    password: "Mot de passe",
    passwordPh: "Saisir le mot de passe",
    submit: "Connexion",
    userNameRequired: "Le compte est requis",
    passwordRequired: "Le mot de passe est requis",
    success: "Connexion réussie",
    sessionFailed:
      "Connexion réussie mais session livraison non établie. Utilisez un compte plateforme (ybps_users).",
  },
};
